<template>
  <ImportUsersModal
    cancelText="cancel"
    :handleCancel="handleCancel"
    :handleMainActionSuccess="handleMainActionSuccess"
    :headerIcon="headerIcon"
    :headerSubtext="headerSubtext"
    :headerText="headerText"
    importType="office365"
    :itemType="itemType"
    :resultsDisclaimerText="disclaimerText"
    :resultsMainActionText="resultsMainActionText"
    :subTextUnderTitle="true"
    :visible="true"
  >
    <template
      v-slot:selectionComponent="slotProps"
    >
      <O365ImportSelection
        :fullHeight="true"
        :o365Id="o365Id"
        :tableImportConditions="slotProps.tableImportConditions"
      />
    </template>
  </ImportUsersModal>
</template>
<script>
import { DirectoryNameConsts, DirectoryTypeConsts, ItemTypeConsts } from 'client/util/Constants';
import CloudDirectoryImportMixin from 'client/directories/mixins/CloudDirectoryImportMixin';
import ImportUsersModal from 'client/components/ImportUsers/ImportUsersModal.vue';
import O365AvatarIcon from 'public/img/icons/microsoft365.svg?inline';
import O365ImportSelection from 'client/directories/Office365/O365ImportSelection.vue';

const displayName = DirectoryNameConsts[DirectoryTypeConsts.office365];

export default {
  name: 'O365Import',

  components: {
    ImportUsersModal,
    O365ImportSelection,
  },

  mixins: [CloudDirectoryImportMixin],

  props: {
    o365Id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      headerIcon: O365AvatarIcon,
      headerText: `Import Users from ${displayName}`,
      itemType: ItemTypeConsts.office365,
      headerSubtext: 'Select the users you want to import from this directory into JumpCloud.',
    };
  },

  computed: {
    disclaimerText() {
      return this.getDisclaimer(displayName);
    },
  },
};
</script>
